import axios from 'axios'
import getEnv from '../lib/get-env.js'

export const getAccountIdentityTypes = async ({ bearerToken }) => {
  const identityTypesResponse = await axios.get(
    `${getEnv(
      'REACT_APP_ACCOUNT_URL'
    )}/v1/identity-types?filter[authVendorId][$eq]=${getEnv(
      'REACT_APP_ACCOUNT_AUTH_VENDOR_ID'
    )}`,
    {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    }
  )
  const identityTypes = identityTypesResponse.data

  return identityTypes
}

export const getAuthVendorIdentityType = async ({ bearerToken, userData }) => {
  const identityTypes = await getAccountIdentityTypes({ bearerToken })
  const typeProperty =
    getEnv('REACT_APP_ACCOUNT_AUTH_VENDOR_TYPE_PROPERTY') || 'provider'
  const identityType = identityTypes.find(
    (x) => x.type === userData.profile[typeProperty]
  )

  return identityType
}
